<script>
import ItemList from '@components/item-list.vue'

export default {
  components: { ItemList },
  props: {
    report : {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      hover: false
    }
  },
  computed: {
    imageUrl() {
      return 'https://static.thatsup.co' + this.report.data.contact.profileImage[this.hover? 1 : 0];
    },
    contactItems() {
      const items = [];
      if(this.report.data.contact.phone) {
        items.push({
          label: this.report.data.contact.phone,
          url: 'callto:' + this.report.data.contact.phone
        });
      }
      if(this.report.data.contact.email) {
        items.push({
          label: this.report.data.contact.email,
          url: 'mailto:' + this.report.data.contact.email
        });
      }
      return items;
    }
  },
}
</script>
<template>
 <div>
    <a :class="$style['image-wrapper']" :href="'mailto:' + report.data.contact.email" @mouseover="hover = true" @mouseout="hover = false">
      <img :class="$style.image" :src="imageUrl" :alt="report.data.contact.name" />
    </a>
    <h3>{{ report.data.contact.name }}</h3>
    <ItemList v-if="contactItems.length" :items="contactItems" />
  </div>
</template>
<style lang="scss" module>
@import '@design';

.image {
  width: $size-grid-size * 16;
  height: $size-grid-size * 16;
  border: 6px solid $color-text;
  border-radius: 50%;
  box-shadow: 0 25px 29px -17px #002535;
  transition: all 0.25s ease-in-out;
  &:hover {
    //box-shadow: 0 25px 29px -17px #588ca2;
  }
}
</style>